// We explicitly don't use backed enum with gids here, as the same buildings might have different gids in Legends & Kingdoms
export enum Building {
    // Training buildings
    Barracks,
    Stable,
    Workshop,
    Residence,
    Palace,
    CommandCenter,
    GreatBarracks,
    GreatStable,
    Hospital,
}